const md5 = require('nano-md5')

const sign = (uriEncodedPath, queryString, token) => {
  // https://github.com/imgix/imgix-blueprint#securing-urls
  const signature = md5(`${token}${uriEncodedPath}${queryString || ''}`)
  return `${uriEncodedPath}${queryString || ''}${queryString ? '&' : '?'}s=${signature}`
}

const buildSrc = (imgUri, params, imgix) => {
  const pairs = []
  params.auto = 'compress,enhance,format'
  for (const key in params) {
    pairs.push(`${key}=${params[key]}`)
  }
  const queryString = `?${pairs.join('&')}`
  const uriEncodedPath = `/${encodeURIComponent(imgUri)}`
  return `${imgix.uri}${sign(uriEncodedPath, queryString, imgix.token)}`
}

export default buildSrc
